import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import "./index.css";
import App from "./App.jsx";
import logger from "./utils/logger";

const SW_UPDATE_INTERVAL_MS = 15 * 60 * 1000;

// Globally disable browser autocomplete on all inputs
document.addEventListener("focusin", (e) => {
  if (e.target?.tagName === "INPUT" && !e.target.hasAttribute("data-ac-set")) {
    e.target.setAttribute("autocomplete", "off");
    e.target.setAttribute("data-ac-set", "1");
  }
}, true);

registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    setInterval(() => registration.update(), SW_UPDATE_INTERVAL_MS);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") registration.update();
    });
  },
  onRegisterError(error) {
    logger.info("ServiceWorker registration failed: ", error);
  },
});

// Old hashed chunk deleted by new deploy — reload to fetch new index.html
window.addEventListener("vite:preloadError", () => window.location.reload());

// Data router (needed for useBlocker); App keeps its own descendant <Routes> under the splat route.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
);
